import axios from 'axios'
import { store } from '../redux/store'
import { setMaintenanceMode, setRedirectError } from '../redux/slices/ServerStatusSlice'
import { clearAuthSession } from '../redux/slices/Auth/login'
import { show as showDrawerRight } from '../redux/slices/Drawer/drawerRight'
import { reloadMapDataForSession } from '../redux/slices/Tree/treeFeatures'
import {
  isMaintenanceResponse,
  loadMaintenanceConfig,
} from '../utils/maintenance'
import { checkBackendStatus } from '../utils/checkBackendStatus'
import { detectCityFromURL } from '../utils/cityDetector'
import { isAccountDisabledError } from '../utils/treePermissions'

const instance = axios.create({
  baseURL: process.env.REACT_APP_URL_BASE,
  timeout: 10000, // 10 segundos
})

// ✅ Interceptar *requests* para agregar token y evitar cache
instance.interceptors.request.use(config => {
  const alreadyHasAuth =
    config.headers?.Authorization || config.headers?.authorization

  if (!alreadyHasAuth) {
    const token = localStorage.getItem('ArbolEc_token')
    if (token && token !== 'null' && token !== 'undefined') {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  const isPhotoEndpoint = config.url?.includes('/tree-photos')
  if (isPhotoEndpoint) {
    const city = detectCityFromURL(window.location.pathname)
    if (city) {
      config.headers['x-tenant-id'] = city
    }
  }

  return config
})

// ✅ Interceptar *respuestas* para manejar errores de red o backend
instance.interceptors.response.use(
  response => response,
  async error => {
    if (isMaintenanceResponse(error)) {
      const maintenanceConfig = await loadMaintenanceConfig()
      store.dispatch(setMaintenanceMode(maintenanceConfig))
      return Promise.reject(error)
    }

    const isNetworkError =
      error.code === 'ERR_NETWORK' &&
      error.request?.status === 0 &&
      error.request?.readyState === 4

    if (isNetworkError) {
      const status = await checkBackendStatus()
      switch (status) {
        case 'offline':
          console.warn('Sin conexión a internet.')
          store.dispatch(setRedirectError('network'))
          break
        case 'backend-down':
          console.warn('El backend no está disponible.')
          store.dispatch(setRedirectError('backend'))
          break
        default:
          console.warn('Error de red no identificado.')
          store.dispatch(setRedirectError('network'))
      }

      return Promise.reject(error)
    }

    // Cuenta deshabilitada en mitad de la sesión: se cierra la sesión local y no queda la ficha en memoria
    if (isAccountDisabledError(error)) {
      store.dispatch(clearAuthSession())
      store.dispatch(showDrawerRight(false))
      store.dispatch(reloadMapDataForSession())
    }

    if (error.response?.status >= 500) {
      console.error('Error del servidor (5xx).')
      store.dispatch(setRedirectError('backend'))
    }

    return Promise.reject(error)
  },
)

export default instance
